import { render, staticRenderFns } from "./ProjectCard.vue?vue&type=template&id=25986faa&scoped=true"
import script from "./ProjectCard.vue?vue&type=script&lang=ts"
export * from "./ProjectCard.vue?vue&type=script&lang=ts"
import style0 from "./ProjectCard.vue?vue&type=style&index=0&id=25986faa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25986faa",
  null
  
)

export default component.exports